<template>
  <div>
    <v-card class="crud-dialog">
      <v-card-title class="headline">
        <v-icon>security</v-icon> N° de Solicitud: {{ tramite.id }}
        <div class="tramite-estado">
          <v-chip label :color="estados[tramite.estado]" text-color="white">
            <small>{{ tramite.estado ? tramite.estado.replace(/_/gi, ' ') : '' }}</small>
          </v-chip>
        </div>
        <v-btn icon @click.native="cerrar_ventana">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs4 v-show="detalles">
            <div class="demofi-container">
              <demofi
                :solicitud="tramite"
                :on-success="cambiarEstado"
                v-if="pdf && tramite.id_archivo > 1"></demofi>
              <v-alert
                outline
                color="red"
                icon="error"
                :value="true"
                v-if="tramite.id_archivo == 1">
                No existe documento para firmar
              </v-alert>
            </div>
            <detalle-doc :solicitud="tramite" v-if="tramite" :pagos="pagos"></detalle-doc>
          </v-flex>
          <v-flex xs8 :class="{ xs12: !detalles }">
            <v-card-actions class="margin-0 p-l-0 p-r-0 p-t-0">
              <v-tooltip top class="margin-0">
                <v-btn
                  type="button"
                  slot="activator"
                  class="margin-0"
                  @click="detalles = !detalles">
                  <v-icon>{{ detalles ? 'chevron_left' : 'chevron_right' }}</v-icon>
                  {{ detalles ? 'Ocultar' : 'Mostrar' }}
                </v-btn>
                <span>{{ detalles ? 'Ocultar' : 'Mostrar' }} detalles</span>
              </v-tooltip>
              <v-spacer></v-spacer>

              <v-tooltip top>
                <v-btn
                  type="button"
                  slot="activator"
                  class="margin-0"
                  v-show="tramite.id_archivo > 1 && this.$store.state.user.id_rol === 7"
                  @click="cambiarDoc()">
                  <v-icon>swap_horiz</v-icon>
                  Cambiar
                </v-btn>
                <span>Cambiar por otro documento</span>
              </v-tooltip>

              <v-btn
                type="button"
                class="margin-0"
                v-show="tramite.id_archivo == 1 && $store.state.archivo > 1 && this.$store.state.user.id_rol === 7"
                @click="cancelarCambio()">
                <v-icon>cancel</v-icon>
                Cancelar cambio
              </v-btn>

              <v-btn
                color="error"
                v-if="$store.state.permissions['tramitesDoc:update']"
                @click.native="openObservar(solicitud)">
                <v-icon>warning</v-icon>
                {{$t('common.observation') }}
              </v-btn>
              <v-btn
                color="success"
                @click="firm(solicitud)"
                :disabled="$store.state.loading"
                v-if="$store.state.permissions['firmas:create'] && pdf !== null && pdfValido === true">
                <v-icon>check</v-icon> {{$t('common.approve') }}
              </v-btn>
            </v-card-actions>

            <div v-if="$store.state.user.id_rol === 6 || $store.state.user.id_rol === 3 || $store.state.user.id_rol === 7">
              <file-upload
                :url="url"
                v-if="tramite.id_archivo == 1"
                :max-filesize="$store.state.maxFilesize"
                label="Arrastre aquí el documento o haga clic aquí para adjuntar el documento PDF para apostillar">
              </file-upload>
            </div>

            <div class="pdf-container">
              <v-layout row wrap v-if="($store.state.user.id_rol === 4 || $store.state.user.id_rol === 3) && solicitud.firmante" class="firma-detalle">
                <v-flex xs6>
                  <h5>Datos del usuario</h5>
                  <strong>Nombre:</strong> {{ solicitud.firmante.firmante_nombre_completo }} <br />
                  <strong>Cargo:</strong> {{ solicitud.firmante.firmante_cargo ||'[no registrado]' }} <br />
                  <strong>Entidad:</strong> {{ solicitud.firmante.entidad_nombre }}<br />
                  <strong>Departamento: </strong> {{solicitud.firmante.firmante_departamento}}<br>
                </v-flex>
                <v-flex xs6 v-if="solicitud.firmante.certicado_token && pdf !== null">
                  <h5>Datos firma en documento</h5>
                  <strong>Nombre:</strong> {{ solicitud.firmante.certicado_token.nombreComunSubject }} <br />
                  <strong>Certificado por:</strong> {{ solicitud.firmante.certicado_token.nombreComunIssuer }} <br />
                  <strong>Fecha inicio validez:</strong> {{ solicitud.firmante.certicado_token.inicioValidez}} <br />
                  <strong>Fecha fin validez:</strong> {{ solicitud.firmante.certicado_token.finValidez }} <br />
                  <!--<strong>Cargo:</strong> {{ solicitud.firmante.certicado_token.unidadOrganizacionalSubject }} <br />-->
                  <!--<strong>Entidad:</strong> {{ solicitud.firmante.certicado_token.organizacionSubject }}-->
                </v-flex>
              </v-layout>
              <v-alert color="warning" icon="warning" value="true" v-if="pdfValido === false && tramite.id_archivo > 1">
                El documento PDF, no es válido o se encuentra corrupto.
              </v-alert>
              <pdf-view :data="pdf" :url="urlPdf" v-bind:valido="validarPdf" v-if="pdf && tramite.id_archivo > 1" ></pdf-view>
              <v-alert color="warning" icon="warning" value="true" v-if="tramite.id_archivo == 1 || !pdf">
                No se adjuntó ningún documento PDF
              </v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="$store.state.modal5" max-width="480">
      <observar :solicitud="solicitud" v-if="solicitud"></observar>
    </v-dialog>
  </div>
</template>

<script>
import FileUpload from '@/common/util/FileUpload.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import Demofi from '@/common/util/Demofi';
import PdfView from '@/common/util/pdf/PdfView';
import Observar from './Observar.vue';
import DetalleDoc from './DetalleDoc';
import tramiteDoc from './mixins/tramite_doc';

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

const mensajes = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'El documento fue enviado correctamente para su posterior firma',
  OBSERVADO_ENTIDAD_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_ENTIDAD_FIRMANTE: 'El documento fue observado correctamente',
  FIRMADO_ENTIDAD: 'El documento fue firmado correctamente',
  REVISADO_CANCILLERIA: 'El documento fue enviado correctamente a cancillería para su verificación',
  OBSERVADO_CANCILLERIA_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'El documento fue observado correctamente',
  APOSTILLADO: 'El documento fue apostillado correctamente'
};

export default {
  props: {
    solicitud: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [ tramiteDoc, crud ],
  data () {
    return {
      estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true,
      pdfValido: false
    };
  },
  created () {
    this.$store.state.modal5 = false;
    // segun rol, verificar que estado a tramite doc corresponde
    if (this.$store.state.user.id_rol === 4) { // firmante cancilleria
      this.solicitud.estadoTramiteDoc = 'APOSTILLADO';
    }
    if (this.$store.state.user.id_rol === 7) { // firmante entidad
      this.solicitud.estadoTramiteDoc = 'FIRMADO_ENTIDAD';
    }

    this.$store.commit('setLoading', false);
    if (this.solicitud) {
      this.getTramite(this.solicitud.id);
    }
  },
  components: {
    FileUpload,
    Demofi,
    Observar,
    DetalleDoc,
    PdfView
  },
  methods: {
    validarPdf (val) {
      if (val === false) this.pdfValido = false;
      else this.pdfValido = true;
    },
    cambiarDoc () {
      this.tramite.id_archivo = 1;
    },
    cancelarCambio () {
      this.tramite.id_archivo = this.$store.state.archivo;
    },
    cerrar_ventana () {
      this.$store.commit('closeModal', 3);
      this.$store.commit('setPin', undefined);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    },
    firm (item) {
      this.$confirm('¿Está seguro que desea aprobar este documento ?', () => {
        // let tipo = this.$store.state.user.id_rol === 4 ? 'CANCILLERIA' : 'ENTIDAD'; // deshabilitado dado que el pago ya no se hace en las entidades
        let tipo = 'CANCILLERIA';

        let pagos = this.pagos.filter(item => item.tipo === tipo);

        if (this.$store.state.user.id_rol === 4) { // solo se verifican pagos en cancillería
          console.log('Iniciando el proceso de firma');
          if (this.tramite.pago_entidad === true) { // Tramite pagado en entidad
            if (document.getElementById('btn-demofi-firm')) {
              this.$store.commit('setData', item);
              document.getElementById('btn-demofi-firm').dispatchEvent(new window.Event('click'));
            } else {
              this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
            }
          } else {
            if (pagos[0] && pagos[0].estado === 'PAGADO') {
              if (document.getElementById('btn-demofi-firm')) {
                this.$store.commit('setData', item);
                document.getElementById('btn-demofi-firm').dispatchEvent(new window.Event('click'));
              } else {
                this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
              }
            } else {
              this.$message.warning(`Debe realizar el pago correspondiente antes para poder firmar el documento`);
            }
          }
        } else { // otro rol que no sea el firmante de cancilleria
          if (document.getElementById('btn-demofi-firm')) {
            this.$store.commit('setData', item);
            document.getElementById('btn-demofi-firm').dispatchEvent(new window.Event('click'));
          } else {
            this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
          }
        }
      });
    },
    openObservar (item) {
      this.solicitud = item;
      this.$store.commit('openModal', 5);
    },
    cambiarEstado (item) {
      if (item.mensajeError) {
        console.log('Error al firmar: ' + item.mensajeError);
        this.$message.error(item.mensajeError);
      } else {
        let estado = this.$store.state.user.id_rol === 4 ? 'APOSTILLADO' : 'FIRMADO_ENTIDAD';
        this.$message.success(mensajes[estado]);
      }
      this.$store.commit('closeModal', 2);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function (val) {
      console.info('Revisando el valor de entrada', val);
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    },
    'solicitud.solicitud.pdfValido': function (pdf) {
      console.info('HOla desde el watch para el pdf', pdf);
    }
  }
};
</script>

<style src="./tramite.scss" lang="scss"></style>

<style lang="scss">
.demofi-container {
  padding: 0 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// Firmante.vue?61f16ff6